// useEffect/useState — 전화번호 표시 주석처리(2026-07-22)로 임시 미사용, 복원 시 import 복구
import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { Form, Input, Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { safeboxClient } from 'myNet'
import { useDispatch } from 'react-redux'
import styles from '../style.module.scss'
import XIcon from '@/assets/images/icon-expired-closed-hover.svg'
import CheckIcon from '@/assets/images/icon-check-24.svg'
import editIcon from '@/assets/images/icon-pencil-24.svg'

const WorkspaceRender = forwardRef((props, ref) => {
  const { workspaceName, isEditingTeamName, setIsEditingTeamName, messageApi, workspaceId, role } =
    props

  const { t } = useTranslation()
  const dispatch = useDispatch()

  // 워크스페이스 탭은 글로벌향 전 구성원에게 노출된다(index.js 게이팅, 2026-07-22 변경).
  // 이름 편집은 owner 전용(2026-07-23 owner/admin → owner 축소). 비소유자에게도 동일한 폼과
  // 연필 아이콘을 보여주되 disabled + 툴팁으로 owner 전용임을 안내한다 (2026-07-23).
  // 글로벌향 role 이 대문자('OWNER')로 내려오는 경로가 있어 toLowerCase 허용목록 비교 (CLAUDE.md 함정)
  const canEditName = ['owner'].includes(String(role || '').toLowerCase())

  /* 전화번호 표시 임시 비활성(주석처리) — 2026-07-22 요청.
     복원 시: 이 블록 + 하단 phoneRow JSX 주석 해제 + react import 에 useEffect/useState 복구.
     전화번호는 고객사(customer) 데이터 기반 회사 연락처 API 로 조회
     (전 구성원 호출 가능 — role 제약 없음, 값이 없으면 서버가 파트너 연락처로 폴백).

  const [companyPhone, setCompanyPhone] = useState(null)

  useEffect(() => {
    let alive = true
    safeboxClient
      .get('/v1/workspaces/company-contact')
      .then((res) => {
        if (!alive) return
        const { data } = res
        if (data?.code === 200) {
          setCompanyPhone(data.data?.company_phone || '')
        } else {
          messageApi.error(t('appConfig.result.failedLoadCompanyInfo'))
        }
      })
      .catch(() => {
        if (!alive) return
        messageApi.error(t('appConfig.result.failedLoadCompanyInfo'))
      })
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  */

  // workspace
  const handleSaveTeamName = async () => {
    console.log('handleSaveTeamName - ')

    try {
      const res = await safeboxClient.put(`/v1/admin/workspaces/${workspaceId}/name`, {
        workspace_name: ref.current.getFieldValue('teamName'),
      })
      const { data } = res
      console.log('data - ', data)

      if (data.code === 200) {
        messageApi.success(t('appConfig.settings.successSaveTeamName'))
        setIsEditingTeamName(false)
        dispatch({
          type: 'user/SET_WORKSPACE_NAME',
          payload: { workspaceName: ref.current.getFieldValue('teamName') },
        })
      } else {
        messageApi.error(t('appConfig.settings.failedSaveTeamName'))
      }
    } catch (error) {
      console.log('error - ', error)
    }
  }

  return (
    <div className={classNames(styles.workspaceContent)}>
      <div className={classNames(styles.content)}>
        <Form ref={ref} initialValues={{ teamName: workspaceName }} colon={false}>
          <Form.Item name="teamName" label={t('appConfig.settings.workspaceName')}>
            <Input
              disabled={!isEditingTeamName}
              className={classNames(styles.teamNameInput, styles.readOnly)}
              value={workspaceName}
              suffix={
                canEditName && isEditingTeamName ? (
                  <div>
                    <Button
                      type="text"
                      icon={<img src={XIcon} alt="cancel" />}
                      onClick={() => {
                        ref.current.resetFields()
                        setIsEditingTeamName(false)
                      }}
                    />
                    <Button
                      type="text"
                      icon={<img src={CheckIcon} alt="save" />}
                      onClick={() => {
                        handleSaveTeamName()
                        setIsEditingTeamName(false)
                      }}
                    />
                  </div>
                ) : (
                  // 비소유자: 연필은 보이되 disabled + owner 전용 안내 툴팁.
                  // disabled 버튼은 마우스 이벤트를 못 받으므로 span 래퍼가 툴팁 트리거 (antd 5 패턴)
                  <Tooltip
                    title={canEditName ? '' : t('appConfig.settings.workspaceNameEditOwnerOnly')}
                  >
                    <span className={classNames(styles.editBtnWrap)}>
                      <Button
                        type="text"
                        disabled={!canEditName}
                        icon={<img src={editIcon} alt="edit" />}
                        onClick={() => setIsEditingTeamName(true)}
                      />
                    </span>
                  </Tooltip>
                )
              }
            />
          </Form.Item>
        </Form>
        {/* 전화번호 표시 임시 비활성(주석처리) — 2026-07-22. 복원 시 상단 상태/effect 블록과 함께 해제.
        <div className={classNames(styles.phoneRow)}>
          <span className={classNames(styles.phoneLabel)}>
            {t('appConfig.settings.companyPhone')}
          </span>
          <span className={classNames(styles.phoneValue)}>{companyPhone || '-'}</span>
        </div>
        */}
      </div>
    </div>
  )
})

WorkspaceRender.displayName = 'WorkspaceRender'

export default WorkspaceRender
